<template>
  <v-dialog v-model="showModal">
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <p class="text-style">
          Are you sure to accept the Task ?
        </p>
      </v-card-title>
      <v-card-text>
        <h2>{{ jobRequestDetails.job.name }}</h2>
        <div class="time-style">
          <p>
            <font class="value-text-style">
              Planned Start Date :
              {{ jobRequestDetails.job.planned_start_date | convertToLocal }}
            </font>
          </p>
          <p>
            <font class="value-text-style">
              Planned End Date : {{ jobRequestDetails.job.planned_end_dat | convertToLocal }}
            </font>
          </p>
        </div>
        <br>
        <div style="text-align: right">
          <v-btn
            class="accept-style"
            elevation="0"
            color="#9FE6BD"
            @click="accepted()"
          >
            Accept
          </v-btn>&nbsp;&nbsp;
          <v-btn
            class="suggest-style"
            elevation="0"
            color="#D9D9D9"
            @click="showModal = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
export default {
  name: 'AcceptJobDialog',
  filters: {
    convertToLocal (stringDatetime) {
      return moment.utc(stringDatetime).local().format('YYYY-MM-DD hh:mm A');
    },
  },
  props: {
    jobRequestDetails: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    showModal: true,
  }),
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    accepted () {
      this.showModal = false;
      this.$emit('accepted');
    },
  },
};
</script>

<style scoped>
.time-style .value-text-style {
  font-size: 12px;
}
p {
  margin-bottom: 0px;
}
.time-style {
  display: flex;
  flex-direction: column;
  padding-top: 6px;
}

.text-style {
  color: #5dad54;
  font-weight: 400;
}

.accept-style,
.suggest-style {
  height: 30px !important;
  font-size: 12px;
  padding: 0px 15px !important;
  font-weight: lighter !important;
  text-transform: none !important;
  color: #101010;
}
</style>
